import react from 'react';
// import { Row, Col, Container } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFacebookF,faTelegram,faLinkedin} from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons'


import '../Styles/ParsicFooter.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../Styles/shared.css';

const ParsicFooter = (props) => {

    return (
        <div className="ParsicFooterBox site-footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-sm-6 col-xs-12">
                        <h1 class="copyright-text" title="Developers' Team Lead: RaminHbb">Copyright &copy; 2020 All Rights Reserved by<a  target="_blank" href="http://www.parsipol.com" > Parsipol</a>.</h1>
                    </div>
                    <div class="col-md-4 col-sm-6 col-xs-12">
                        <ul class="social-icons">                   
                            <li><a className="facebook"  target="_blank" href="https://www.facebook.com/Parsicpol"><FontAwesomeIcon icon={faFacebookF}/></a></li>
                            <li><a class="telegram" target="_blank" href="https://t.me/joinchat/AAAAAEJHW8wsDhOqJCu-1A"><FontAwesomeIcon icon={faTelegram}/></a></li>
                            <li><a class="linkedin" target="_blank" href="https://www.linkedin.com/company/parsipol"><FontAwesomeIcon icon={faLinkedin}/></a></li>
                            {/* <li><a class="voip" href="tel:02144804472"><FontAwesomeIcon icon={faPhone}/></a></li> */}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ParsicFooter;